import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { KkmModalComponent } from '../kkms/kkm-modal.component';
import { CtoModalComponent } from '../cto/cto-modal.component';
import { CtoModulesModalComponent } from '../cto-modules/cto-modules.component';
import { ModalService } from '../../../core/modal/modal.service';
import { CtoApiService } from '../../../core/modules/cto/cto-api.service';
import { ICto } from '../../../core/modules/cto/cto.types';

export interface INewCto { // TODO replace this interface
  cto: ICto;
  kkmIds: Array<number>;
  permissions: Array<string>;
  userAgreement?: boolean;
}

@Component({
  selector: 'tax-new-cto',
  templateUrl: './new-cto.component.html',
  styleUrls: ['./new-cto.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class NewCtoComponent implements OnDestroy {
  kkms: string = '';
  modules: string = '';
  newCto: INewCto = {
    cto: {
      name: '',
      iinOrBin: '',
      address: '',
      contacts: '',
      // @ts-ignore
      servicedModels: null,
      rca: '',
    },
    kkmIds: [],
    permissions: [],
    userAgreement: false,
  };

  isSaveButtonPressed: boolean = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private ctoApiService: CtoApiService,
    private location: Location,
    private changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService,
    private router: Router,
    private modalService: ModalService,
  ) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  openCtoModal(): void {
    this.modalService.openOld(CtoModalComponent, {
      initialState: this.newCto,
    }, {
      width: '740px',
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedCto: ICto) => {
        if (!selectedCto) {
          return;
        }
        this.newCto.cto = selectedCto;
        this.changeDetectorRef.detectChanges();
      });
  }

  openKkmsModal(): void {
    this.modalService.openOld(KkmModalComponent, {
      initialState: this.newCto.kkmIds,
    }, {
      width: '740px',
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedItems: number[]) => {
        if (!selectedItems) {
          return;
        }
        this.newCto.kkmIds = selectedItems;
        this.kkms = selectedItems.length ? `ID: ${selectedItems.join(', ')}` : '';
        this.changeDetectorRef.detectChanges();
      });
  }

  openModulesModal(): void {
    this.modalService.openOld(CtoModulesModalComponent, {
      initialState: this.newCto.permissions,
    }, {
      width: '740px',
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedItems: string[]) => {
        if (!selectedItems) {
          return;
        }
        this.newCto.permissions = selectedItems;
        this.modules = selectedItems.map(item => this.translate.instant(item))
          .join(', ');
        this.changeDetectorRef.detectChanges();
      });
  }

  goBack(): void {
    this.location.back();
  }

  canSaveCto(): boolean {
    // @ts-ignore
    return (
      this.newCto.permissions.length > 0
      && this.newCto.kkmIds.length > 0
      && this.newCto.cto
      && this.newCto.userAgreement);
  }

  saveCto(): void {
    this.isSaveButtonPressed = true;
    this.ctoApiService.saveCto(this.newCto)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => { this.router.navigate(['main/cto']); },
      );
  }
}
